import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import classes from "./Pagination.module.css";

const Pagination = (props) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPages, setTotalPages] = useState(null);

  useEffect(() => {
    setCurrentPage(props.currentPage);
    setTotalPages(props.totalPages);
  }, [props]);

  const handleForwardLabel = () => {
    const page = currentPage === totalPages ? currentPage : currentPage + 1;
    setCurrentPage(page);
    props.handlePaginationClick(page);
  };

  const handleBackwardLabel = () => {
    const page = currentPage === 1 ? currentPage : currentPage - 1;
    setCurrentPage(page);
    props.handlePaginationClick(page);
  };

  const atStart = currentPage === 1;
  const atEnd = currentPage === totalPages;

  return (
    <nav className={classes["pagination-container"]} aria-label="Pagination">
      <button
        type="button"
        className={classes["arrow"]}
        onClick={handleBackwardLabel}
        disabled={atStart}
        aria-label="Previous page"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <div className={classes["current-page"]}>
        <span className={classes["page-number"]}>{currentPage}</span>
        <span className={classes["page-of"]}>of</span>
        <span className={classes["page-number"]}>{totalPages}</span>
      </div>
      <button
        type="button"
        className={classes["arrow"]}
        onClick={handleForwardLabel}
        disabled={atEnd}
        aria-label="Next page"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </nav>
  );
};

export default Pagination;
